import { render } from "./manual.vue?vue&type=template&id=ae433a5e&scoped=true"
import script from "./manual.vue?vue&type=script&lang=js"
export * from "./manual.vue?vue&type=script&lang=js"

import "./manual.vue?vue&type=style&index=0&id=ae433a5e&lang=css&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae433a5e"]])

export default __exports__